/* eslint-disable prettier/prettier */
import axios from 'axios'

const state = {
    totalPoRequestForFinalApproval: null,
    isFetchingTotalPoRequestForFinalApproval: false
}

const mutations = {
    // eslint-disable-next-line no-unused-vars
    getTotalPoRequestForFinalApproval(state, payload) {
        state.isFetchingTotalPoRequestForFinalApproval = true
        axios.get(`api/miscdata/total-po-request-for-final-approval`).then(response => {
            state.totalPoRequestForFinalApproval = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isFetchingTotalPoRequestForFinalApproval = false)
    }
}

const actions = {
    getTotalPoRequestForFinalApproval({
        commit
    }, payload) {
        commit('getTotalPoRequestForFinalApproval', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}